import styled from 'styled-components';

const ErrorMessage = styled.div`
  font-size: 1.5rem;
  color: #d9534f;
  text-align: center;
`;

export default ErrorMessage;
